module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_vm._v("OUTCASTS")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Thornberry looked up at Jordan from beneath his shaggy brows. “Do you, now?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What is it?” Brandon demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Let’s wait until the others get here,” Jordan said. “I’ll explain it to all of you at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thornberry looked curious, Elyse worried. Brandon put on the irritated look that Jordan had seen all his brother’s life: half sulking, half impatience.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("One by one the other members of the team filtered into the wardroom: three more women, five men. They all looked uncertain, a bit shaky. Only to be expected after an eighty-year sleep, Jordan thought. You didn’t look too peppy yourself, those first few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("How will they feel once they’ve heard the news I have to tell them? he asked himself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The others helped themselves to food and drink, then slowly sat at the tables and watched the screen displays from Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon sat himself beside Elyse and said, “All right, Jordy. We’re all here. What is it that you’ve got to tell us?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan stepped in front of the wall screen and looked at the eleven of them. Four women, seven men, their eyes focused on him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m afraid I have some disappointing news,” he began. “There isn’t going to be a backup mission.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No backup? But the IAA—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“There’s been a second wave of greenhouse flooding,” Jordan tried to explain. “Even worse than the original floods, five generations ago. The World Council has reneged on the backup missions, they’ve got too much reconstruction and resettlement to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But we’ve seen nothing about such flooding on the news vids,” said Harmon Meek, springing to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The team’s astrobiologist, Meek was a scarecrow of a man, tall and almost painfully thin, all bones and gangling limbs. He was dressed almost formally, in a starched white shirt and a dark brown ascot, no less, with neatly creased trousers of charcoal gray. His thick mop of sandy blond hair looked as if it hadn’t seen a brush in eighty years; his eyebrows were so pale they were almost invisible, and the cold blue eyes beneath them looked terribly perplexed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m afraid the vids were edited by the IAA,” Jordan said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nonsense!” Meek snapped. “I don’t believe you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan smiled wanly at the astrobiologist, so full of righteous indignation. He commanded the communications system to show Ionescu’s message.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Meek sank back into his chair and the team watched the message from Earth, with its scenes of devastation, in shocked silence.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s Volgograd,” said Tanya Verishkova, in a choked whisper. “Flooded.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Look at the refugees.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Miles of ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So that’s the situation,” Jordan said, once the images winked off. “It doesn’t change our circumstances, really. But it means that when we leave, there won’t be a backup team to take over from us, or on its way.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Geoffrey Hazzard, the astronautical engineer and nominal captain of their ship, muttered, “Just like Apollo.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What do you mean?” Elyse Rudaki asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hazzard was an African-American from Pennsylvania, tall and rangy, his skin the color of mocha, his long-jawed face slightly horsy-looking, although his dark eyes were large and expressive.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The first missions to the Moon,” he explained. “They put a dozen men on the Moon inside of a few years, then stopped altogether. It was more than half a century before anybody went back.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well,” Jordan said, trying to put up as good a face as possible, “we all knew we’d be pioneers in exploring New Earth. Now we’re even more so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From his seat beside Elyse, Brandon gave out a bitter laugh. “Pioneers, are we? We’re all outcasts, that’s what we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Outcasts, is it?” Thornberry snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Pointing to the wall-screen displays of the news vids from Earth, Brandon said, “Outcasts. Gone and forgotten. Twelve people, sent to explore a planet—a whole world! Just the twelve of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Mildly, Jordan said to his brother, “Bran, we’re merely the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("first")]), _vm._v(" twelve to be sent here. There will be others, you know. In time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sooner or later. There’s got to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thornberry said, “We’ve got robots, remotely controlled roving vehicles, all sorts of sensors and satellites. There’s more than just the twelve of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Think about it,” Brandon replied, almost sneering. “Think about what we’re doing. We’ve spent eighty years getting here. Eighty years. We’re supposed to explore this planet for at least five years. Then we head back to Earth, another eighty years.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But we haven’t aged,” Elyse said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What of it? When we get back home, damned near two hundred years will have passed. Two hundred years! We’ll be strangers in our own world. We’re already strangers. Outcasts.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As mildly as he could manage, Jordan said, “No one forced you to join this mission, Bran. We’re all volunteers. We all knew the risks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Oh, sure, volunteers,” Brandon retorted. “I "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("volunteered")]), _vm._v(" because my department head made it clear that if I didn’t I wouldn’t get tenure; I’d be an assistant professor for another ten years or more.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I volunteered willingly,” said Elyse. “I considered it an honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Very noble of you,” Brandon muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Come to think of it,” Thornberry said, rubbing his jaw, “the university’s president didn’t ask me if I wanted this mission. He told me I was the only man on the faculty who could do the job.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, that’s quite an honor,” Jordan said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe,” Thornberry replied, drawing out the word. “But I got the impression that what he meant was that I was the only man on the faculty that he could spare.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You see?” Brandon said. “We’re expendables. Outcasts.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Who’s an outcast?” Meek demanded angrily. “I’m certainly not.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Aren’t you?” Brandon countered. “We’ve thrown away everything we knew back on Earth to take part in this mission, this fool’s errand. When we get back to Earth—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("if")]), _vm._v(" we get back—we’ll be strangers in our own world.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan started to say, “Bran, why don’t you—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But Brandon plowed on, “Don’t you see? They picked us for this mission because we’re expendable. If we don’t get back it’ll be no loss to anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Expendable?” Meek snapped. “I’m not expendable. Young man, I’ll have you know that I was selected over the top people in the field of astrobiology. The very top.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon gave Meek a condescending smile. “Are you married?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t see what that’s got to do with anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re single. Lifelong bachelor, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, yes, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Any dependents?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Frowning, Meek replied, “No direct family, no. I have a couple of distant cousins.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t have any direct family, either,” said Brandon. “Except for my big brother, here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thornberry, with his curious little smile, said, “You know, Brandon me lad, you didn’t have to come on this jaunt. You could’ve said no.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s not true,” Brandon said, with some heat. “I wasn’t really given a choice. Were you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Seeing their tempers rising, Jordan said, “I think we’ve beaten this subject into the ground, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But Meek was nettled. “Now look here, Dr. Kell. You may think lightly of yourself, but I regard us—all of us, including your brother—as the cream of the crop. The absolute cream.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Especially yourself,” Brandon sneered.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Now that’s enough,” Jordan said firmly. “We are here and we have a job to do. It’s a big job, a huge job, and it’s the most important mission human beings have ever undertaken. Enough said. The subject is closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Brandon glared at his brother, then finally shrugged, grudgingly. Meek still looked nettled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan commanded the display screen to resume showing the planet below them. Enough of eight-year-old newscasts and messages of regret, he told himself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The wardroom fell silent as the twelve of them stared at the planet sliding past on the wall screen.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It looks so much like home,” Elyse breathed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, doesn’t it,” said Jordan.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec84e26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 93
// module chunks = 0